// services
import { Http } from "@shared/svelte/Modules/ApiService";

// stores
import { dwollaIdentityStore } from "@retailer/svelte/stores/DwollaIdentityStore";

// types
import type { HTTPParams } from "@shared/types/HTTP";

export const get = async () => {
  const requestData: HTTPParams = {
    method: "GET",
    url: "/api/retailer/payments/dwolla_identity"
  };

  const errCB = () => {
    dwollaIdentityStore.update(state => ({ ...state, loaded: true, failed: true }));
  };

  const successCB = res => {
    dwollaIdentityStore.set({ payment_identity: res['payment_identity'], provider: res['provider'], loaded: true, failed: false });
  };

  await Http(requestData, successCB, errCB);
}